var _class, _GeoJsonParameterEditor;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import PropTypes from "prop-types";
import defined from "terriajs-cesium/Source/Core/defined";
import Styles from "./parameter-editors.scss";
import { selectOnMap as selectPointOnMap, getDisplayValue as getPointParameterDisplayValue } from "./PointParameterEditor";
import { selectOnMap as selectPolygonOnMap, getDisplayValue as getPolygonParameterDisplayValue } from "./PolygonParameterEditor";
import { selectOnMap as selectExistingPolygonOnMap, getDisplayValue as getExistingPolygonParameterDisplayValue } from "./SelectAPolygonParameterEditor";
import { getDisplayValue as getRegionPickerDisplayValue } from "./RegionPicker";
import GeoJsonParameter from "../../Models/FunctionParameters/GeoJsonParameter";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { runInAction } from "mobx";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let GeoJsonParameterEditor = observer(_class = (_GeoJsonParameterEditor = class GeoJsonParameterEditor extends Component {
  onCleanUp() {
    this.props.viewState.openAddData();
  }
  selectPointOnMap() {
    runInAction(() => {
      this.props.parameter.setValue(CommonStrata.user, undefined);
      selectPointOnMap(this.props.previewed.terria, this.props.viewState, this.props.parameter, this.props.t("analytics.selectLocation"));
      this.props.parameter.subtype = GeoJsonParameter.PointType;
    });
  }
  selectPolygonOnMap() {
    runInAction(() => {
      this.props.parameter.setValue(CommonStrata.user, undefined);
      selectPolygonOnMap(this.props.previewed.terria, this.props.viewState, this.props.parameter);
      this.props.parameter.subtype = GeoJsonParameter.PolygonType;
    });
  }
  selectExistingPolygonOnMap() {
    runInAction(() => {
      this.props.parameter.setValue(CommonStrata.user, undefined);
      selectExistingPolygonOnMap(this.props.previewed.terria, this.props.viewState, this.props.parameter);
      this.props.parameter.subtype = GeoJsonParameter.SelectAPolygonType;
    });
  }
  render() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx("strong", {
          children: t("analytics.selectLocation")
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "container",
        style: {
          marginTop: "10px",
          marginBottom: "10px",
          display: "table",
          width: "100%"
        },
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: () => this.selectPointOnMap(),
          className: Styles.btnLocationSelector,
          children: /*#__PURE__*/_jsx("strong", {
            children: t("analytics.point")
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          style: {
            marginLeft: "2%",
            marginRight: "2%"
          },
          onClick: () => this.selectPolygonOnMap(),
          className: Styles.btnLocationSelector,
          children: /*#__PURE__*/_jsx("strong", {
            children: t("analytics.polygon")
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          onClick: () => this.selectExistingPolygonOnMap(),
          className: Styles.btnLocationSelector,
          children: /*#__PURE__*/_jsx("strong", {
            children: t("analytics.existingPolygon")
          })
        })]
      }), /*#__PURE__*/_jsx("input", {
        className: Styles.field,
        type: "text",
        readOnly: true,
        value: getDisplayValue(this.props.parameter.value, this.props.parameter)
      }), getDisplayValue(this.props.parameter.value, this.props.parameter) === "" && /*#__PURE__*/_jsx("div", {
        children: t("analytics.nothingSelected")
      })]
    });
  }
}, _defineProperty(_GeoJsonParameterEditor, "propTypes", {
  previewed: PropTypes.object,
  parameter: PropTypes.object,
  viewState: PropTypes.object,
  t: PropTypes.func.isRequired
}), _GeoJsonParameterEditor)) || _class;
function getDisplayValue(value, parameter) {
  if (!defined(parameter.subtype)) {
    return "";
  }
  if (parameter.subtype === GeoJsonParameter.PointType) {
    return getPointParameterDisplayValue(value);
  }
  if (parameter.subtype === GeoJsonParameter.SelectAPolygonType) {
    return getExistingPolygonParameterDisplayValue(value);
  }
  if (parameter.subtype === GeoJsonParameter.PolygonType) {
    return getPolygonParameterDisplayValue(value);
  }
  return getRegionPickerDisplayValue(value, parameter);
}
export default withTranslation()(GeoJsonParameterEditor);